import { Column } from "@/components";
import { SheetCertifications } from "@/components/user-sheet/profile-editors/SheetCertifications";
import { SheetEducations } from "@/components/user-sheet/profile-editors/SheetEducations";
import { SheetProfessionalSummary } from "@/components/user-sheet/profile-editors/SheetProfessionalSummary";
import { SheetSkills } from "@/components/user-sheet/profile-editors/SheetSkills";
import { SheetWorkExperiences } from "@/components/user-sheet/profile-editors/SheetWorkExperiences";
import type { UserSheetProfile } from "@/components/user-sheet/types";
import { withRequiredFields } from "@/components/user-sheet/withRequiredFields";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const ProfilePreviewDialog = ({
  onOpenChange,
  open,
  profile,
}: {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  profile: UserSheetProfile;
}) => {
  /* Render */
  const render = () => {
    return (
      <Dialog onOpenChange={onOpenChange} open={open}>
        <DialogContent className="max-h-[90vh] max-w-5xl overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Candidate Profile</DialogTitle>
          </DialogHeader>
          <Column className="gap-6">
            <SheetProfessionalSummary
              professionalSummary={profile.professionalSummary}
            />
            <SheetWorkExperiences
              workExperiences={withRequiredFields(profile.workExperience, [
                "id",
              ])}
            />
            <SheetEducations
              educations={withRequiredFields(profile.education, ["id"])}
            />
            <SheetCertifications
              certifications={withRequiredFields(profile.certifications, [
                "id",
              ])}
            />
            <SheetSkills skills={withRequiredFields(profile.skills, ["id"])} />
          </Column>
        </DialogContent>
      </Dialog>
    );
  };

  return render();
};
